export { default } from "./AppInit-component";
